import React from 'react';

import { useIsNonInteractiveViewer } from '@app/ui';
import { useInitiateUserLogin, useUserIsLoggedIn } from '@app/user';
import { useTranslation } from 'react-i18next';
import { ButtonLink } from '@app/router';
import { NavFooter } from './Footer.styles';

const Footer = () => {
  const { t } = useTranslation();
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const handleSignUpLoginClick = useInitiateUserLogin();
  const isLoggedIn = useUserIsLoggedIn();

  if (isLoggedIn) {
    return null;
  }

  return (
    <NavFooter>
      <ButtonLink
        variant="secondary"
        size="lg"
        width="45%"
        className="login"
        onClick={() =>
          handleSignUpLoginClick('login', {
            state: { forceLogin: true },
          })
        }
        roll="button"
        to={isNonInteractiveViewer ? '/login' : ''}
      >
        {t('Log In')}
      </ButtonLink>
      <ButtonLink
        variant="primary"
        size="lg"
        width="45%"
        onClick={() =>
          handleSignUpLoginClick('signup', {
            state: { forceLogin: true },
          })
        }
        roll="button"
        to={isNonInteractiveViewer ? '/signup' : ''}
      >
        {t('Sign Up')}
      </ButtonLink>
    </NavFooter>
  );
};

export default Footer;
